import { memo } from 'react';

const EmptyFolderSvg = () => (
  <svg width="187" height="98" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M178.969 90.397c-1.028 0-2.006.21-2.899.586C174.151 81.852 166.122 75 156.504 75c-11.047 0-20.004 9.04-20.004 20.194 0 .953.07 1.888.197 2.806H186.5c0-4.199-3.372-7.603-7.531-7.603ZM31.167 19.668c-.123 0-.245.009-.365.019C30.382 13.715 25.405 9 19.323 9c-5.168 0-9.54 3.405-10.995 8.093a5.915 5.915 0 0 0-1.9-.317A5.926 5.926 0 0 0 .5 22.701c0 .447.053.88.147 1.299H35.5a4.333 4.333 0 0 0-4.333-4.332Z"
      fill="#88E2E9"
    />
    <path
      d="M134.548 71.98V17.51c0-4.37-3.54-7.91-7.91-7.91h-47.61l-3.81-5.89A8.142 8.142 0 0 0 68.398 0h-16.86c-3.74 0-6.78 3.04-6.78 6.78v65.2c0 2.21 1.79 4 4 4h81.79c2.21 0 4-1.79 4-4Z"
      fill="#F470BD"
    />
    <path
      d="M72.328 23.47h76.7c4.33 0 7.22 4.47 5.43 8.42l-18.33 40.59a5.95 5.95 0 0 1-5.43 3.51h-83.18c-1.3 0-2.16-1.34-1.63-2.52l21-46.5a5.95 5.95 0 0 1 5.43-3.51l.01.01Z"
      fill="#F8B1DC"
    />
  </svg>
);

export default memo(EmptyFolderSvg);
